import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as invoiceActionTypes from '../invoiceActionTypes';

const searchInvoicePartnerLocationGeolocation = function* searchInvoicePartnerLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {invoiceId, searchQueryString} = payload;

    yield fork(
        fetchRequest,
        invoiceActionTypes.SEARCH_INVOICE_PARTNER_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString},
    );

    const responseActionType = yield take([
        invoiceActionTypes.SEARCH_INVOICE_PARTNER_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        invoiceActionTypes.SEARCH_INVOICE_PARTNER_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseActionType.error) {
        const {response} = responseActionType.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: invoiceActionTypes.SET_INVOICE_PARTNER_LOCATION_CANDIDATES,
            payload: {
                arcGISLocationCandidateDTOs,
                invoiceId,
                searchQueryString,
            },
        });
    }
};

export default searchInvoicePartnerLocationGeolocation;
